import { Clock } from "lucide-react";
import React from "react";

interface LastPaymentDetailsCardProps {
  totalBillAmount: number;
  lastPaymentAmount: number;
  lastPaymentDate: string;
  currentOutstanding: number;
  currency: string;
}

export const LastPaymentDetailsCard: React.FC<LastPaymentDetailsCardProps> = ({
  totalBillAmount,
  lastPaymentAmount,
  lastPaymentDate,
  currentOutstanding,
  currency,
}) => {
  return (
    <div className="rounded-lg border border-yellow-200 bg-yellow-50 px-6 py-4">
      {/* Header */}
      <div className="flex items-center gap-2 text-yellow-800 font-semibold mb-3">
        <Clock className="h-4 w-4" />
        <span>Last Payment Details</span>
      </div>

      <div className="border-t border-yellow-200 mb-4" />

      {/* Content */}
      <div className="grid grid-cols-3 gap-8">
        {/* Total Bill Amount */}
        <div>
          <p className="text-sm uppercase tracking-wide text-yellow-700">
            Total Bill Amount
          </p>
          <p className="mt-1 text-lg font-bold text-gray-900">
            {currency} {totalBillAmount}
          </p>
        </div>

        {/* Last Payment */}
        <div>
          <p className="text-sm uppercase tracking-wide text-yellow-700">
            Last Payment
          </p>
          <p className="mt-1 text-lg font-bold text-gray-900">
            {currency} {lastPaymentAmount}
          </p>
          <p className="text-sm text-gray-500 mt-0.5">{lastPaymentDate}</p>
        </div>

        {/* Current Outstanding */}
        <div>
          <p className="text-sm uppercase tracking-wide text-yellow-700">
            Current Outstanding
          </p>
          <p className="mt-1 text-lg font-bold text-orange-700">
            {currency} {currentOutstanding}
          </p>
        </div>
      </div>
    </div>
  );
};
